import { render, staticRenderFns } from "./WorkOrder.vue?vue&type=template&id=b10985f2&"
import script from "./WorkOrder.vue?vue&type=script&lang=js&"
export * from "./WorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrder.vue?vue&type=style&index=0&id=b10985f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports